module.exports = {"440115001":"南沙街道","440115002":"珠江街道","440115003":"龙穴街道","440115100":"万顷沙镇","440115101":"横沥镇","440115102":"黄阁镇","440115103":"东涌镇","440115104":"大岗镇","440115105":"榄核镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440115.json
// module id = 1953
// module chunks = 0